<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<VehicleReportTable></VehicleReportTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import VehicleReportTable from '@/components/Realtime/VehicleReportTable.vue';

export default {
	name: 'VehicleReport',
	components: {
		VehicleReportTable
	}
};
</script>
